import { render, staticRenderFns } from "./GreetingModal.vue?vue&type=template&id=42b0b6c8&scoped=true"
import script from "./GreetingModal.vue?vue&type=script&lang=js"
export * from "./GreetingModal.vue?vue&type=script&lang=js"
import style0 from "./GreetingModal.vue?vue&type=style&index=0&id=42b0b6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b0b6c8",
  null
  
)

export default component.exports